import {IHostingCacheExcludeState} from "../reducers/hosting-cache-exclude.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getCacheExcludeHostingState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingCacheExclude);

export const getCacheExclude = (websiteId: number) => createSelector(getCacheExcludeHostingState,
  (state: IHostingCacheExcludeState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? state.entities[websiteId].entities : null
);


export const getCacheExcludeMap = (websiteId: number) => createSelector(getCacheExcludeHostingState,
  (state: IHostingCacheExcludeState) =>
    state.entities[websiteId]
);


export const getCacheExcludeLoading = (websiteId: number) => createSelector(getCacheExcludeHostingState,
  (state: IHostingCacheExcludeState) =>
    state.entities[websiteId].loading
);

export const getCacheExcludeLoaded = (websiteId: number) => createSelector(getCacheExcludeHostingState,
  (state: IHostingCacheExcludeState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
